import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { Reveal, ChapterLabel } from "./Reveal";
import { FAQ_ITEMS } from "../data/lots";

export const FAQ = () => (
  <section id="faq" data-testid="faq-section" className="bg-cream py-24 lg:py-36">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12">
      <div className="lg:col-span-4">
        <Reveal>
          <ChapterLabel number="05" title="Questions" />
          <h2 className="font-serif text-4xl sm:text-5xl text-forest leading-[1.05] tracking-tight">
            Frequently Asked <span className="italic text-brass">Questions</span>
          </h2>
        </Reveal>
      </div>
      <div className="lg:col-span-8">
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full">
            {FAQ_ITEMS.map((item, i) => (
              <AccordionItem key={item.q} value={`faq-${i}`} className="border-b border-border" data-testid={`faq-item-${i}`}>
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="font-serif text-xl sm:text-2xl text-forest text-left py-6 hover:text-brass hover:no-underline transition-colors duration-300"
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="font-sans text-base leading-relaxed text-muted-foreground pb-6">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </div>
  </section>
);
